<template>
  <v-container>
    <template>
   <CRUDList
      ref="crudList"
      :canAdd="canAddToSharedList"
      :canEdit="true"
      :canSave="canEditSharedList"
      :showSelect="false"
      :canDeleteInDialog="canDeleteFromSharedList"
      :enableFixedHeaders="true"
      :displayTopPagination="false"
      :headers="headers"
      :baseCrudKey="baseCrudKey"
      :dialogHeaderName="dialogHeaderName"
      :defaultSortBy="defaultSortBy"
      :tableTitle="dialogHeaderName"
      dialogDynamicWidth="20vw"
      tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='450'
      @upsertItem="upsertRecords"
      @deleteItem="deleteFromDiaglog"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      @loadCRUDList="handleLoadTaxAdjList"
    >
    <template v-slot:[`editedItem`]="{}">
      <taxAdjTypesDialog
      :baseCrudKey="baseCrudKey"
      />
    </template>
    </CRUDList>
    </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { taxAdjTypesHeader } from '../Utils/taxHeaders.utils';
import taxAdjTypesDialog from './taxAdjTypesDialog.vue';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import '../../../assets/style.css';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';

export default {
  name: 'taxAdjTypesList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxAdjTypesDialog,
  },
  data() {
    return {
      selectedRows: [],
      baseCrudKey: 'taxAdjTypesList',
      selectedRow: null,
      dialogHeaderName: 'Adj Types',
      headers: taxAdjTypesHeader,
      gridLoading: defaultGridLoading(),
    };
  },

  destroyed() {
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapGetters('shared/taxAdjTypesShared', [
      // 'getDialog',
    ]),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'adjType',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapActions('shared/taxAdjTypesShared', [
      'loadtaxAdjTypesSharedRecords',
      'upserttaxAdjTypes',
      'deleteTaxAdjType',
    ]),
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      if (updatedItem.assessorCodes) {
        updatedItem.assessorCodes = item.assessorCodes.split(',');
      }
      await this.upserttaxAdjTypes({
        item: updatedItem, baseCrudKey, postProcessTrans: this.postProcessAdjTypesUpdate,
      });
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteTaxAdjType({ item, baseCrudKey });
      }
    },
    handleLoadTaxAdjList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      manageGridLoading(this, true, 'Searching...');
      this.loadtaxAdjTypesSharedRecords({
        criteria, baseCrudKey, postProcessTrans: this.postProcessAdjTypes,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    postProcessAdjTypes(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        item.assessorCodes = item.assessorCodes ? item.assessorCodes.join(',') : '';
        updatedItems.push(item);
      }
      return updatedItems;
    },
    postProcessAdjTypesUpdate(items) {
      const item = { ...items };
      item.assessorCodes = item.assessorCodes ? item.assessorCodes.join(',') : '';
      return item;
    },
  },
};
</script>
